import AWS from 'aws-sdk';
import { parse } from 'url'; // Importing the 'parse' function from the 'url' module
import { uuid } from 'uuidv4';

const BUCKET_NAME = 'padhai-aurait-tech'
const REGION = "ap-south-1";


AWS.config.update({
    region: REGION,
    accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID,
    secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY,
  });

const s3 = new AWS.S3();

export async function postTeacherChatFile(file, teacherId, chatId, filename) {
  const fileName = `Teachers/${teacherId}/chats/${chatId}/attachment/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
  };

  try {
    // Upload file to S3
    const uploadResult = await s3.upload(params).promise();
    return uploadResult.Location; // Get the URL of the uploaded file
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}

export async function postTeacherAnnouncementFile(file, teacherId, classRoomId, filename) {
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/announcements/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classRoomId}/announcements/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}



export async function postTeacherUploadFileFOrQuestionBankAnswerKey( selectedFile,filename) {
  const teacherId = localStorage.getItem("teacherId");
  const classRoomId = localStorage.getItem("classRoomId");
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/QuestionBank/AnswerKey/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: selectedFile,
    ContentType: selectedFile.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classRoomId}/QuestionBank/AnswerKey/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}

export async function postTeacherQuestionbankImageFile ( selectedFile,filename,keypath) {
  const teacherId = localStorage.getItem("teacherId");
  const classRoomId = localStorage.getItem("classRoomId");
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/QuestionBank/images/keypath/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: selectedFile,
    ContentType: selectedFile.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classRoomId}/QuestionBank/images/keypath/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}



export async function postTeacherUploadFileFOrQuestionBank( selectedFile,filename) {
  const teacherId = localStorage.getItem("teacherId");
  const classRoomId = localStorage.getItem("classRoomId");
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/QuestionBank/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: selectedFile,
    ContentType: selectedFile.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classRoomId}/QuestionBank/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}


export async function postDemoAccountFileStudyBuddy(file ,uuidCreated,  filename) {
  const fileName = `demo/${uuidCreated}/${file}/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/demo/${uuidCreated}/${file}/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}
export async function postTeacherAssignmentFile(file, teacherId, assignmentName, filename) {
    const classRoomId=localStorage.getItem("classRoomId")
    console.log("ye postfile se aya",assignmentName);
    
    const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/assignments/${assignmentName}/ReferenceMaterial/${filename}`;

    const params = {
      Bucket: BUCKET_NAME,
      Key: fileName, // Path in the S3 bucket
      Body: file,
      ContentType: file.type,
      Expires: 1800
    };

    try {
      // Upload file to S3
      //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
      const uploadResult = await s3.upload(params).promise();
      return {url: uploadResult.Location, uri: `Teachers/${teacherId}/classroom/${classRoomId}/assignments/${assignmentName}/ReferenceMaterial/${filename}` }; 
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('Error uploading file');
    }
}

export async function postTeacherQuizFile(file, teacherId, quizName, filename) {
    const classRoomId=localStorage.getItem("classRoomId")
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/quiz/${quizName}/ReferenceMaterial/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `Teachers/${teacherId}/classroom/${classRoomId}/quiz/${quizName}/ReferenceMaterial/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}

export async function postTeacherExcallyNotes(file, teacherId, filename,noteId) {
  const classRoomId=localStorage.getItem("classRoomId")
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/notes/${noteId}/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `Teachers/${teacherId}/classroom/${classRoomId}/notes/${noteId}/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}

export async function postTeacherDigitiseNotes(file, teacherId, filename,noteTitle) {
  const classRoomId=localStorage.getItem("classRoomId")
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/Digitisenotes/${noteTitle}/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `Teachers/${teacherId}/classroom/${classRoomId}/Digitisenotes/${noteTitle}/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}
 

export async function postTeacherAssignmentQuestionImage(file, teacherId, assignmentName, filename,questionNumber,classRoomId) {
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/assignments/${assignmentName}/images/${questionNumber}/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classRoomId}/assignments/${assignmentName}/images/${questionNumber}/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}
export async function postTeacherQuizQuestionImage(file, teacherId, quizName, filename,questionNumber,classRoomId) {
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/quiz/${quizName}/images/${questionNumber}/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classRoomId}/quiz/${quizName}/images/${questionNumber}/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}

 

export async function postTeacherThumbnailCourse(file, teacherId, classRoomId, filename,courseTitle) {
  // Extract the first folder from the filename
  const folderName = filename.split('/')[0]; // Get the first folder name from the filename
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/eLearning/${courseTitle}/${folderName}/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3 (creating the folder if necessary)
    // S3 automatically creates folders if they don't exist as part of the key structure
    const uploadResult = await s3.upload(params).promise();
    return {
      url: uploadResult.Location,
      uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classRoomId}/eLearning/${courseTitle}/${folderName}/${filename}`,
    };
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}

export async function postTeacherElearningCourseVideo(file, teacherId, classRoomId, filename,courseTitle,topic,subtopic) {
  // Extract the first folder from the filename
  const folderName = filename.split('/')[0]; // Get the first folder name from the filename
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/eLearning/${courseTitle}/${topic}/${subtopic}/${folderName}/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3 (creating the folder if necessary)
    // S3 automatically creates folders if they don't exist as part of the key structure
    const uploadResult = await s3.upload(params).promise();
    return {
      url: uploadResult.Location,
      uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classRoomId}/eLearning/${courseTitle}/${topic}/${subtopic}/${folderName}/${filename}`,
    };
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}





export async function postJsonInS3OfYoutubeNotesTeacher(file, teacherId, coursetitle,topic,subtopic,filename) {
   const classroomId=localStorage.getItem("classRoomId")
  const fileName = `Teachers/${teacherId}/classroom/${classroomId}/eLearning/${coursetitle}/${topic}/${subtopic}/Jsons/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `Teachers/${teacherId}/classroom/${classroomId}/eLearning/${coursetitle}/${topic}/${subtopic}/Jsons/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}
export async function postTeacherLibraryFile(file, teacherId, classRoomId, filename) {
  const folderName = filename; 
  const sanitizedFilename = filename.replace(/\s+/g, "_");
  
  // Construct S3 file path
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/library/${folderName.replace(/\s+/g, "_")}/${sanitizedFilename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, 
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    const uploadResult = await s3.upload(params).promise();
    
    return {
      url: encodeURI(uploadResult.Location), 
      uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classRoomId}/library/${folderName.replace(/\s+/g, "_")}/${sanitizedFilename}`,
    };
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}


export async function postScreenshotTeacherLibrary(file, teacherId, classRoomId, filename) {
  const fileName = `Teachers/${teacherId}/classroom/${classRoomId}/library/screenshot/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classRoomId}/library/screenshot/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}

export async function postTeacherProfilePhoto(file, teacherId, filename) {
  const fileName = `Teachers/${teacherId}/profilePhoto/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/profilePhoto/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}



export async function generatePresignedUrl(s3Url, expiresIn = 1800) {
  const parsedUrl = parse(s3Url);
  let key = decodeURIComponent(parsedUrl.pathname.slice(1));
  
  // Fix the key path - replace /eacher/ with /Teachers/
  if (key.includes('/eacher/')) {
    console.log('Original key:', key);
    key = key.replace('/eacher/', '/Teachers/');
    console.log('Corrected key:', key);
  }

  const params = {
    Bucket: BUCKET_NAME,
    Key: key,
    Expires: expiresIn, // 30 minutes in seconds
  };

  try {
    // Generate the pre-signed URL using S3 SDK
    const signedUrl = await s3.getSignedUrlPromise('getObject', params);
    return signedUrl;
  } catch (error) {
    console.error('Error generating pre-signed URL:', error);
    throw error;
  }
}
 
export async function postTeacherExamFile(file, teacherId, exam_topic, filename) {
  const fileName = `Teachers/${teacherId}/exams/${exam_topic}/ReferenceMaterial/${filename}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/exams/${exam_topic}/ReferenceMaterial/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}
 
export async function postTeacherImagePdfImage(file, teacherId, noteTitle, filename) {
  const sanitize = str => str.replace(/[^a-zA-Z0-9-_]/g, '-');
const safeNoteTitle = sanitize(noteTitle);
  const classroomId=localStorage.getItem("classRoomId")
const fileName = `Teachers/${teacherId}/classroom/${classroomId}/DigitiseNotes/${safeNoteTitle}/Images/${filename}`;
  
  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classroomId}/DigitiseNotes/${safeNoteTitle}/Images/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}
 

export async function postTeacherImageAskAiLatex(file, teacherId, noteTitle, filename) {
 const sanitize = str => str.replace(/[^a-zA-Z0-9-_]/g, '-');
const safeNoteTitle = sanitize(noteTitle);
  const classroomId=localStorage.getItem("classRoomId")
const fileName = `Teachers/${teacherId}/classroom/${classroomId}/digitisedNotes/${safeNoteTitle}/ask-ai/${filename}`;


  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `Teachers/${teacherId}/classroom/${classroomId}/digitisedNotes/${safeNoteTitle}/ask-ai/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}

export async function postTeacherLatexCompileFile(file, teacherId, noteTitle, filename) {
 const sanitize = str => str.replace(/[^a-zA-Z0-9-_]/g, '-');
const safeNoteTitle = sanitize(noteTitle);
  const classroomId=localStorage.getItem("classRoomId")
const fileName = `Teachers/${teacherId}/classroom/${classroomId}/digitisedNotes/${safeNoteTitle}/${filename}`;


  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/classroom/${classroomId}/digitisedNotes/${safeNoteTitle}/${filename}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}
export async function postNotesFile(file, teacherId, refId) {
  const fileName = `Teachers/${teacherId}/notes/${refId}`;

  const params = {
    Bucket: BUCKET_NAME,
    Key: fileName, // Path in the S3 bucket
    Body: file,
    ContentType: file.type,
    Expires: 1800
  };

  try {
    // Upload file to S3
    //s3://{bucketName}/Teachers/${teacherId}/assignments/${assignmentName}/ReferenceMaterial/${filename}
    const uploadResult = await s3.upload(params).promise();
    return {url: uploadResult.Location, uri: `s3://padhai-aurait-tech/Teachers/${teacherId}/notes/${refId}` }; 
  } catch (error) {
    console.error('Error uploading file:', error);
    alert('Error uploading file');
  }
}